import React from 'react';
import { TbKey, TbLogout } from 'react-icons/tb';
import { useAppDispatch, useAppSelector } from 'stores';
import { logout } from 'stores/auth';
import useModal from 'hooks/useModal';
import ChangePassword from './ChangePassword';
import {
  profileWrap,
  profile,
  avatar,
  profileText,
  logoutButton,
} from './style';

interface Props {
  isCollapsed?: boolean;
}

function Profile({ isCollapsed = false }: Props) {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const { handleModal } = useModal();

  const displayName = user?.name || user?.username || '';
  const orgLabel = Array.from(
    new Set(user?.roles.map((r) => r.organizationName ?? '') ?? []),
  ).join(', ');

  return (
    <div css={profileWrap(isCollapsed)}>
      {user && (
        <div
          css={profile(isCollapsed)}
          title={user.email ? `${displayName} (${user.email})` : displayName}
        >
          <span css={avatar}>{displayName.slice(0, 1).toUpperCase()}</span>
          <span css={profileText(isCollapsed)}>
            <strong>{displayName}</strong>
            {orgLabel && <small>{orgLabel}</small>}
          </span>
        </div>
      )}
      {user && (
        <button
          type="button"
          css={logoutButton(true)}
          onClick={() =>
            handleModal('비밀번호 변경', <ChangePassword />, <></>)
          }
          aria-label="비밀번호 변경"
          title="비밀번호 변경"
        >
          <TbKey size={18} />
        </button>
      )}
      <button
        type="button"
        css={logoutButton(true)}
        onClick={() => dispatch(logout())}
        aria-label="로그아웃"
        title="로그아웃"
      >
        <TbLogout size={18} />
      </button>
    </div>
  );
}

export default Profile;
